import { render } from "./ApeConstructorNavigation.vue?vue&type=template&id=297f4a44"
import script from "./ApeConstructorNavigation.vue?vue&type=script&lang=js"
export * from "./ApeConstructorNavigation.vue?vue&type=script&lang=js"

import "./ApeConstructorNavigation.vue?vue&type=style&index=0&id=297f4a44&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__